import React from 'react'
import { useHistory } from 'react-router-dom'
import { useLocalStorage } from 'react-use'
import { useUserState } from 'src/hooks'
import axios from 'src/utils/request'


function useRequest(service: any): Function
function useRequest(service: any, needState: boolean): [Function, any]
function useRequest(service: any, needState?: boolean): any {
    const [ userState, serUserState ] = useUserState()
    const [state, setState] = React.useState('')
    const [ userStorage ] = useLocalStorage<any>('user', {})

    React.useEffect(() => {
        if(!userState.isLogin && userStorage.token) {
            serUserState({
                isLogin: true,
                token: userStorage.token
            })

            axios.setHeader({
                Authorization : 'Bearer ' + userStorage.token
            })
        }
    }, [userState.isLogin])

    const history = useHistory()
    const start = (params?: any) =>  {
        return service(params)
        /* .then((res: any)  => {
            console.log(111, res)
            return res
        }) */
        .catch((res: AxiosResponse)  => {
            if(res?.data?.code === 10003) {
                history.push('/login')
            }
            return Promise.reject(res)
        }).finally(() => {
            setState('finish')
        })
    }

    if(needState) {
        return [
            start,
            {
                finish: state === 'finish'
            }
        ]
    }

    return start
}

export {useRequest}